<template>
	<div>
		<div class="searchTop space_between">
			<el-form inline class="el-form">
				<el-form-item>
					<el-date-picker v-model="datePicker" value-format="yyyy-MM-dd" type="daterange" range-separator="至"
						start-placeholder="开始日期" end-placeholder="结束日期" size="small" :clearable="false">
					</el-date-picker>
				</el-form-item>
				<el-form-item>
					<el-select v-model="queryApi.companyId" filterable clearable size="small" placeholder="请选择媒体公司"
						@change="companySelectChange" style="width: 280px;">
						<el-option v-for="item in companyOptions" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-select v-model="queryApi.platformId" filterable clearable size="small"
						@change="networkOptionsChange" placeholder="请选择广告网络" style="width: 280px;">
						<el-option v-for="item in networkOptions" :key="item.platformId" :label="item.label"
							:value="item.platformId">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-select v-model="queryApi.platformNetworkId" filterable clearable size="small"
						placeholder="请选择账号名称" style="width: 280px;">
						<el-option v-for="item in accountOptions" :key="item.value" :label="item.label" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-select v-model="queryApi.os" filterable clearable size="small" placeholder="请选择操作系统"
						style="width: 280px;">
						<el-option v-for="item in osOptions" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-select v-model="appSelectForm" clearable @change="appSeleteChange" size="small" value-key="value"
						popper-class="appNameIdOptions" :popper-append-to-body="false" filterable placeholder="请选择应用"
						:remote-method="appRemoteMethod" :loading="appRemoteLoading" remote @clear="getMediaAppOption()"
						style="width: 280px;">
						<el-option v-for="item in mediaAppOptions" :key="item.value" :value="item"
							:label="`应用：${item.label} | ${item.value}`">
							<div class="selectTemp2">
								<div class="selectAppName">{{item.label}}</div>
								<div class="selectAppId flex_start">
									<div>{{item.value}}</div>
									<img @click.stop="copyName(item.value)" src="../../assets/icon/copy.png" alt="" />
								</div>
							</div>
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-select v-model="queryApi.adType" filterable clearable size="small" placeholder="请选择广告类型"
						style="width: 280px;">
						<el-option v-for="item in adTypeOptions" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-select v-model="adsSelectFormChannel" clearable @change="channelAdsSeleteChange" size="small"
						value-key="value" popper-class="appNameIdOptions" :popper-append-to-body="false" filterable
						@clear="getChannelAdsOption(2)" :remote-method="channelAdsRemoteMethod"
						:loading="adsRemoteLoading" remote placeholder="请选择广告源" style="width: 280px;">
						<el-option v-for="(item,index) in channelAdsOptions" :key="index"
							:label="`广告源：${item.label} | ${item.value}`" :value="item">
							<div class="selectTemp2">
								<div class="selectAppName">{{item.label}}</div>
								<div class="selectAppId flex_start">
									<div>{{item.value}}</div>
									<img @click.stop="copyName(item.value)" src="../../assets/icon/copy.png" alt="" />
								</div>
							</div>
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-select v-model="adsSelectFormMedia" clearable @change="mediaAdsSeleteChange" size="small"
						value-key="value" popper-class="appNameIdOptions" :popper-append-to-body="false" filterable
						@clear="getMediaAdsOption(2)" :remote-method="mediaAdsRemoteMethod" :loading="adsRemoteLoading"
						remote placeholder="请选择聚合广告位" style="width: 280px;">
						<el-option v-for="(item,index) in mediaAdsOptions" :key="index"
							:label="`${item.label} | ${item.value}`" :value="item">
							<div class="selectTemp2">
								<div class="selectAppName">{{item.label}}</div>
								<div class="selectAppId flex_start">
									<div>{{item.value}}</div>
									<img @click.stop="copyName(item.value)" src="../../assets/icon/copy.png" alt="" />
								</div>
							</div>
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-input v-model="budgetSource" clearable size="small" placeholder="请输入预算名称"
						style="width: 280px;"></el-input>
				</el-form-item>
			</el-form>
			<div class="menu-right">
				<el-button @click="searchReset" size="small">重置</el-button>
				<div></div>
				<el-button type="primary" @click="apiQuery" size="small">查询</el-button>
			</div>
		</div>

		<!-- 预算占比数据概览，表格样式与其他运营分析页面保持一致 -->
		<div class="tableBox">
			<el-table v-loading="analysisLoading" :data="analysisData" row-key="key" empty-text="暂无数据"
				:header-cell-style="{color:'#333333',background:'#EAEFF5'}" class="el_table">
				<el-table-column prop="budgetName" label="预算种类" min-width="140">
					<template slot-scope="scope">
						<div class="budgetName" :title="scope.row.budgetName">{{scope.row.budgetName}}</div>
					</template>
				</el-table-column>
				<el-table-column label="数据概览图" min-width="500">
					<template slot-scope="scope">
						<div class="progressTrack">
							<div class="progressBar" :style="{width: scope.row.percentage + '%'}"></div>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="竞价出价平均值/元" width="140">
					<template slot-scope="scope">
						<div>{{scope.row.winPriceAverage}}</div>
					</template>
				</el-table-column>
				<el-table-column label="渠道出价平均值/元" width="140">
					<template slot-scope="scope"><div>{{scope.row.bidPriceAverage}}</div></template>
				</el-table-column>
				<el-table-column label="占比" width="100">
					<template slot-scope="scope">{{formatPercentage(scope.row.percentage)}}</template>
				</el-table-column>
				<el-table-column label="展现数" width="120">
					<template slot-scope="scope">{{formatNumber(scope.row.showCount)}}</template>
				</el-table-column>
				<el-table-column label="总数" width="120">
					<template slot-scope="scope">{{formatNumber(scope.row.totalCount)}}</template>
				</el-table-column>
			</el-table>
			<div class="paging" style="display: flex;justify-content: flex-end;margin-top: 20px;">
				<el-pagination @size-change="handleSizeChange" background @current-change="handleCurrentChange"
					:current-page="currentPage" :page-sizes="[10, 20, 30, 50]" :page-size="pageSize"
					layout="total, sizes, prev, pager, next, jumper" :total="total">
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'BudgetProportionAnalysis',
		data() {
			return {
				// 页面查询条件，与聚合解析链接页面顶部筛选项保持一致
				queryApi: {
					companyId: '',
					platformId: '',
					platformNetworkId: '',
					os: '',
					adType: '',
				},
				datePicker: [], // 日期筛选范围
				budgetSource: '', // 预算来源筛选值
				companyOptions: [], // 媒体公司下拉列表
				selectedCompanyLabel: '', // 当前选中公司的名称，仅用于查询应用下拉
				networkOptions: [], // 广告网络下拉列表
				accountOptions: [], // 账号名称下拉列表
				osOptions: this.$api.osOptions, // 操作系统下拉列表
				adTypeOptions: this.$api.adsTypeOptions, // 广告类型下拉列表
				mediaAppOptions: [], // 应用下拉列表
				channelAdsOptions: [], // 广告源下拉列表
				mediaAdsOptions: [], // 聚合广告位下拉列表
				appSelectForm: {}, // 当前选中的应用
				adsSelectFormChannel: {}, // 当前选中的广告源
				adsSelectFormMedia: {}, // 当前选中的聚合广告位
				appRemoteLoading: false, // 应用远程搜索加载状态
				adsRemoteLoading: false, // 广告位远程搜索加载状态
				analysisLoading: false, // 预算占比数据加载状态
				analysisData: [], // 格式化后的预算占比数据
				currentPage: 1, // 当前页码
				pageSize: 10, // 每页条数
				total: 0, // 数据总条数
				appSearchTimer: null, // 应用远程搜索防抖定时器
				adsSearchTimer: null, // 广告位远程搜索防抖定时器
			}
		},
		mounted() {
			this.dateInit()
			this.getCompanyOption()
			this.getNetworkOtions()
			this.getAccountOptions()
			this.getChannelAdsOption(2)
			this.getMediaAdsOption(2)
			this.getMediaAppOption()
			this.getAnalysisData()
		},
		beforeDestroy() {
			// 组件销毁时清理远程搜索定时器
			clearTimeout(this.appSearchTimer)
			clearTimeout(this.adsSearchTimer)
		},
		methods: {
			// 初始化日期筛选范围为当天
			dateInit() {
				const date = new Date()
				const dateText = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`
				this.datePicker = [dateText, dateText]
			},
			// 将对象型筛选项补充到接口请求参数中
			appendSelectValue(data) {
				if (this.appSelectForm && this.appSelectForm.value) {
					data.appId = this.appSelectForm.value
				}
				if (this.adsSelectFormChannel && this.adsSelectFormChannel.value) {
					data.platformAdId = this.adsSelectFormChannel.value
				}
				if (this.adsSelectFormMedia && this.adsSelectFormMedia.value) {
					data.mediaAdId = this.adsSelectFormMedia.value
				}
			},
			// 组装预算占比接口的查询参数
			getQueryData() {
				const data = {
					startDate: this.datePicker[0],
					endDate: this.datePicker[1],
					...this.queryApi,
					pageNum: this.currentPage,
					pageSize: this.pageSize,
				}
				const source = this.budgetSource.trim()
				if (source) {
					data.selectedSourceList = [source]
				}
				this.appendSelectValue(data)
				return data
			},
			// 请求并格式化预算占比分析数据
			async getAnalysisData() {
				this.analysisLoading = true
				try {
					const res = await this.$http.post(
						this.$api.operationalAnalysis.budgetSourceRatio,
						this.getQueryData()
					)
					if (res.code == 200 || res.code == 1) {
						const data = res.data || {}
						const list = Array.isArray(data.list) ? data.list : []
						this.analysisData = list.map((item, index) => this.formatAnalysisItem(item, index))
						this.total = data.totalRecord || 0
					} else {
						this.analysisData = []
						this.total = 0
					}
				} finally {
					this.analysisLoading = false
				}
			},
			// 将接口数据转换为页面展示所需的预算占比数据
			formatAnalysisItem(item, index) {
				return {
					key: `${item.source || 'budget'}-${index}`,
					budgetName: item.source || '-',
					winPriceAverage: item.winPriceAverage,
					bidPriceAverage: item.bidPriceAverage,
					percentage: this.normalizePercentage(item.ratio),
					showCount: item.displayCount == null ? 0 : item.displayCount,
					totalCount: item.totalCount == null ? 0 : item.totalCount,
				}
			},
			// 将接口返回的百分比限制在进度条可展示的范围内
			normalizePercentage(value) {
				const numberValue = Number(value)
				if (Number.isNaN(numberValue)) {
					return 0
				}
				return Math.min(Math.max(numberValue, 0), 100)
			},
			// 格式化占比文本，整数不保留小数
			formatPercentage(value) {
				const numberValue = Number(value)
				return `${Number.isInteger(numberValue) ? numberValue : numberValue.toFixed(2)}%`
			},
			// 格式化展现数和总数，增加千分位便于阅读
			formatNumber(value) {
				const numberValue = Number(value)
				return Number.isNaN(numberValue) ? value : numberValue.toLocaleString('zh-CN')
			},
			// 获取媒体公司下拉列表
			async getCompanyOption() {
				const res = await this.$http.get(this.$api.common.companyOption)
				this.companyOptions = res.data || []
			},
			// 切换媒体公司后刷新应用列表
			companySelectChange(companyId) {
				const selectedCompany = this.companyOptions.find(item => item.value === companyId)
				this.selectedCompanyLabel = selectedCompany ? selectedCompany.label : ''
				this.appSelectForm = {}
				this.mediaAppOptions = []
				this.getMediaAppOption()
			},
			// 获取应用下拉列表
			async getMediaAppOption(query = null) {
				const data = {
					mediaCompany: this.selectedCompanyLabel,
					appId: query,
				}
				const res = await this.$http.get(this.$api.common.mediaAppOption, data)
				this.appRemoteLoading = false
				this.mediaAppOptions = res.data || []
			},
			// 保存当前选中的应用
			appSeleteChange(value) {
				this.appSelectForm = value || {}
			},
			// 防抖搜索应用下拉数据
			appRemoteMethod(query) {
				clearTimeout(this.appSearchTimer)
				this.appSearchTimer = setTimeout(() => {
					this.appRemoteLoading = true
					this.getMediaAppOption(query)
				}, 300)
			},
			// 获取聚合广告位下拉列表
			async getMediaAdsOption(type, query = null) {
				const res = await this.$http.get(this.$api.common.mediaAdsOption, { adsName: query })
				this.adsRemoteLoading = false
				this.mediaAdsOptions = res.data || []
			},
			// 保存当前选中的聚合广告位
			mediaAdsSeleteChange(value) {
				this.adsSelectFormMedia = value || {}
			},
			// 防抖搜索聚合广告位下拉数据
			mediaAdsRemoteMethod(query) {
				clearTimeout(this.adsSearchTimer)
				this.adsSearchTimer = setTimeout(() => {
					this.adsRemoteLoading = true
					this.getMediaAdsOption(2, query)
				}, 300)
			},
			// 获取广告源下拉列表
			async getChannelAdsOption(type, query = null) {
				const res = await this.$http.post(this.$api.common.channelAdsOption, { adsId: query })
				this.adsRemoteLoading = false
				this.channelAdsOptions = res.data || []
			},
			// 保存当前选中的广告源
			channelAdsSeleteChange(value) {
				this.adsSelectFormChannel = value || {}
			},
			// 防抖搜索广告源下拉数据
			channelAdsRemoteMethod(query) {
				clearTimeout(this.adsSearchTimer)
				this.adsSearchTimer = setTimeout(() => {
					this.adsRemoteLoading = true
					this.getChannelAdsOption(2, query)
				}, 300)
			},
			// 获取广告网络下拉列表
			async getNetworkOtions() {
				const res = await this.$http.get(this.$api.mediaAd.networkOptionDistinct)
				this.networkOptions = res.data || []
			},
			// 切换广告网络后刷新对应账号列表
			networkOptionsChange(platformId) {
				this.accountOptions = []
				this.queryApi.platformNetworkId = ''
				this.getAccountOptions(platformId)
			},
			// 获取账号名称下拉列表
			async getAccountOptions(platformId) {
				const res = await this.$http.get(this.$api.mediaAd.networkAccountOption, { platformId })
				this.accountOptions = res.data || []
			},
			// 复制下拉项中的应用或广告位 ID
			async copyName(text) {
				try {
					await navigator.clipboard.writeText(text)
					this.$message.success('复制成功')
				} catch (error) {
					this.fallbackCopy(text)
				}
			},
			// 在剪贴板 API 不可用时使用输入框完成复制
			fallbackCopy(text) {
				const input = document.createElement('input')
				input.value = text
				document.body.appendChild(input)
				input.select()
				document.execCommand('copy')
				document.body.removeChild(input)
				this.$message.success('复制成功')
			},
			// 修改每页条数后返回第一页并重新查询
			handleSizeChange(value) {
				this.currentPage = 1
				this.pageSize = value
				this.getAnalysisData()
			},
			// 切换页码后查询对应页数据
			handleCurrentChange(value) {
				this.currentPage = value
				this.getAnalysisData()
			},
			// 重置所有筛选项并重新查询
			searchReset() {
				this.currentPage = 1
				this.pageSize = 10
				this.queryApi = {
					companyId: '',
					platformId: '',
					platformNetworkId: '',
					os: '',
					adType: '',
				}
				this.budgetSource = ''
				this.selectedCompanyLabel = ''
				this.appSelectForm = {}
				this.adsSelectFormChannel = {}
				this.adsSelectFormMedia = {}
				this.dateInit()
				this.getAnalysisData()
			},
			// 按当前筛选条件查询预算占比数据
			apiQuery() {
				this.currentPage = 1
				this.getAnalysisData()
			},
		},
	}
</script>

<style scoped>
	.searchTop {
		background: #ffffff;
		padding: 20px;
	}

	.el-form {
		align-items: center;
		display: flex;
		justify-content: flex-start;
		flex-wrap: wrap;
		margin-bottom: 25px;
	}

	.searchTop .el-form {
		margin-bottom: 0;
	}

	/deep/ .el-form-item {
		margin-right: 10px !important;
		margin-bottom: 0;
	}

	.menu-right {
		margin-left: auto;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	}

	.tableBox {
		margin-top: 10px;
		background: #ffffff;
		padding: 16px;
		box-sizing: border-box;
	}

	.budgetName {
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}

	.progressTrack {
		width: 100%;
		height: 14px;
		overflow: hidden;
		background: #f0f0f0;
	}

	.progressBar {
		height: 100%;
		background: #2f7df6;
		transition: width 0.3s ease;
	}

	/deep/.appNameIdOptions .el-select-dropdown__item {
		height: 48px !important;
		line-height: 48px !important;
	}

	.selectTemp2 {
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: center;
	}

	.selectAppName,
	.selectAppId {
		font-size: 12px;
		color: #333333;
		line-height: 20px;
	}

	.selectAppId {
		color: #999999;
		align-items: center;
	}

	.selectAppId img {
		width: 14px;
		height: 14px;
		margin-left: 3px;
	}
</style>
